import { render, staticRenderFns } from "./AppAsideBarPerfiles.vue?vue&type=template&id=b76424ae&scoped=true"
import script from "./AppAsideBarPerfiles.vue?vue&type=script&lang=js"
export * from "./AppAsideBarPerfiles.vue?vue&type=script&lang=js"
import style0 from "./AppAsideBarPerfiles.vue?vue&type=style&index=0&id=b76424ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76424ae",
  null
  
)

export default component.exports